import { Skeleton } from "@/shared/ui";

interface Props {
  cardsOnly?: boolean;
}

function RowsGridSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from({ length: 12 }).map(function renderRowSkeleton(_, i) {
        return (
          <div
            key={i}
            className="flex items-center p-1 radius-md surface-component-fill">
            <div className="flex justify-between items-center flex-1 radius-sm p-4 surface-base-fill">
              <div className="flex items-center gap-3">
                <Skeleton width={16} height={16} />
                <Skeleton width={140} height={14} />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton width={52} height={14} />
                <Skeleton width={18} height={18} />
              </div>
            </div>
            <div className="w-12 h-12 flex items-center justify-center">
              <Skeleton width={20} height={20} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function AttachedDocumentsPageSkeleton({ cardsOnly }: Props) {
  if (cardsOnly) return <RowsGridSkeleton />;

  return (
    <div className="radius-3xl surface-base-fill p-7">
      <div className="flex items-center justify-between gap-2 mb-7">
        <div className="flex items-center gap-2">
          <Skeleton width={192} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton width={180} height={36} className="radius-xs" />
        </div>
      </div>

      <RowsGridSkeleton />
    </div>
  );
}
